module.exports = __webpack_public_path__ + "customer6.png?bfe5ec4aca4ed57e86751e685fc88e3f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/customer6.png
// module id = 118
// module chunks = 0